export const version = "wallet/5.0.11";
//# sourceMappingURL=_version.js.map